import styled, { css, keyframes } from "styled-components";
import heroImgUrl from '../assets/Hero.jpg';
import buildingImgUrl from '../assets/Building.jpg';
import { usePreloadImage } from "hooks/usePreloadImage";
import { ProjectList } from "features/project";

const sharpen = keyframes`
    from {
        filter: brightness(.5) blur(20px);
    }

    to {
        filter: brightness(.5) blur(0px);
    }
`;

const HeroWrapper = styled.div`
    height: calc(100vh - 80px);
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    z-index: 0;
    
    h1 {
        color: var(--light-text);
    }

    @media (max-width: 50rem) {
        height: unset;
    }
`;

const HeroImage = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    background: var(--brown);
    background-position: center;
    background-size: cover;
    background-image: url(data:image/jpeg;base64,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);
    filter: brightness(.5) blur(20px);
    z-index: 0;
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 7.5rem), 0% 100%);
    
    ${props => props.loaded && css`
    animation: ${sharpen} .25s linear forwards;
    background-image: url(${props.image});
    `}
    
    @media only screen and (max-width: 50rem) {
        clip-path: polygon(0 0, 100% 0, 100% 85%, 0% 100%);
    }
`;

const HeroContent = styled.div`
    width: 100%;
    z-index: 1;
    font-size: 5rem;
    color: white;
    text-shadow: 6px 4px 8px #333;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding: 0 10%;

    img {
        height: 30rem;
        width: 22.5rem;
        border: 1px solid white;
        box-shadow: 6px 4px 8px #333;
    }

    @media (max-width: 50rem) {
        flex-direction: column;
    }
`;

const Section = styled.section`
    padding: 1rem 10rem 4rem;

    @media (max-width: 50rem) {
        padding: 0 5rem;
    }

    @media (max-width: 37.5rem) {
        padding: 0 1rem;
    }
`;

export const Home = () => {

    const { image, loaded } = usePreloadImage(heroImgUrl);

    return (
        <>
            <HeroWrapper>
                <HeroImage image={image} loaded={loaded} />
                <HeroContent>
                    <h1 className="slide-in-left">Jon's Workshop</h1>
                    <img className="slide-in-right" src={buildingImgUrl} alt="Jon applying finish to live edge table" />
                </HeroContent>
            </HeroWrapper>
            <Section id="projects">
                <h2>Projects:</h2>
                <ProjectList />
            </Section>
            <Section id="about">
                <h2>About:</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
            </Section>
        </>
    )
}